class ApkMegaMenu {
  constructor() {
    this.menuToggle = document.getElementById("menuToggle");
    this.megaMenu = document.getElementById("megaMenu");
    this.menuColumns = document.querySelectorAll(".apk-menu-column");
    this.menuItems = document.querySelectorAll(".apk-menu-item"); // Todos os itens
    this.menuItemsWithSubmenu = document.querySelectorAll(
      ".apk-menu-item[data-submenu]"
    );
    this.submenuContents = document.querySelectorAll(".apk-submenu-content");
    this.backButton = document.getElementById("backButton");

    this.isOpen = false;
    this.activeLevel = 1;
    this.activeItems = new Map(); // Para rastrear itens ativos por nível
    this._isMobile = window.innerWidth <= 1024; // Cached; updated on resize
    this._level1Column = document.querySelector(".apk-level-1"); // Cached column refs
    this._level2Column = document.querySelector(".apk-level-2");
    this.isToggling = false; // Prevenir execução simultânea

    this.init();
  }

  init() {
    this.bindEvents();
    this.setupInitialState();
  }

  // Track menu item access
  trackMenuAccess(element) {
    let menuItemId = null;

    // Check if element is a direct link with menu item ID
    if (element.dataset && element.dataset.menuItemId) {
      menuItemId = element.dataset.menuItemId;
    } else {
      // Check if element is a menu item container with a link inside
      const link = element.querySelector(".apk-menu-link");
      menuItemId = link ? link.dataset.menuItemId : null;
    }

    if (menuItemId) {
      // Send AJAX request to track the access
      const ajaxConfig = window.apkAjax;
      if (!ajaxConfig) return;

      const params = new URLSearchParams();
      params.append("action", "track_menu_access");
      params.append("menu_item_id", menuItemId);
      params.append("nonce", ajaxConfig.nonce);

      fetch(ajaxConfig.ajaxUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: params.toString(),
      }).catch((error) => {
        console.error("Error tracking menu access:", error);
      });
    }
  }

  bindEvents() {
    // Toggle do menu principal
    this.menuToggle.addEventListener("click", (e) => {
      e.preventDefault();
      this.toggleMenu();
    });

    // Botão voltar no mobile
    if (this.backButton) {
      this.backButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.goBackFromLevel3();
      });
    }

    // Fechar menu ao clicar fora
    document.addEventListener("click", (e) => {
      if (
        !e.target.closest(".apk-navigation") &&
        !e.target.closest("#menuToggle")
      ) {
        this.closeMenu();
      }
    });

    // Evento mouseleave para o megaMenu para limpar estados de hover
    this.megaMenu.addEventListener("mouseleave", () => {
      if (!this._isMobile && this.isOpen) {
        // Limpar todos os estados ativos quando sai do menu
        this.clearActiveItems();
      }
    });

    // Eventos nos itens do menu
    this.menuItems.forEach((item) => {
      // Hover para desktop (aplicado a todos os itens)
      if (!this._isMobile) {
        item.addEventListener("mouseenter", (e) => {
          this.handleItemHover(e.currentTarget);
        });
      }

      // Click sempre ativo (todos os itens)
      item.addEventListener("click", (e) => {
        this.handleMenuItemClick(e, item);
      });
    });

    // Delegação de eventos para itens do nível 2 mobile (criados dinamicamente)
    document.addEventListener("click", (e) => {
      const mobileLevel2Item = e.target.closest(
        ".mobile-level-2 .apk-menu-item"
      );
      if (mobileLevel2Item && this._isMobile) {
        const submenuKey = mobileLevel2Item.dataset.submenu;
        if (submenuKey) {
          // Item com submenu - prevenir navegação e mostrar submenu
          e.preventDefault();
          this.showLevel3Overlay(submenuKey);
        } else {
          // Item sem submenu - permitir navegação normal
          const link = mobileLevel2Item.querySelector(".apk-menu-link");
          if (link && link.href && link.href !== "#") {
            // Track the access before navigation
            this.trackMenuAccess(mobileLevel2Item);

            // Link válido - verificar target
            if (link.target === "_blank") {
              window.open(link.href, "_blank");
            } else {
              window.location.href = link.href;
            }
          }
          this.closeMenu();
        }
      }
    });

    // Eventos de keyboard navigation
    this.menuItems.forEach((item) => {
      const link = item.querySelector(".apk-menu-link");
      link.addEventListener("keydown", (e) => {
        this.handleKeyNavigation(e, item);
      });
    });

    // Fechar menu com ESC
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.isOpen) {
        if (this.activeLevel === 3 && this._isMobile) {
          this.goBackFromLevel3();
        } else {
          this.closeMenu();
          this.menuToggle.focus();
        }
      }
    });

    // Detectar mudanças de orientação/redimensionamento
    window.addEventListener("resize", () => {
      this._isMobile = window.innerWidth <= 1024;
      if (!this._isMobile && this.isOpen) {
        // Reset para comportamento desktop
        this.resetToDesktop();
      }
    });

    // Track clicks in 'Mais acessados' section
    document.addEventListener("click", (e) => {
      const mostViewsLink = e.target.closest(
        ".apk-mega-most-views .apk-menu-link"
      );
      if (mostViewsLink && mostViewsLink.dataset.menuItemId) {
        // Track the access
        this.trackMenuAccess(
          mostViewsLink.closest(".apk-menu-item") || mostViewsLink
        );
      }
    });

    // Track clicks in submenu title links
    document.addEventListener("click", (e) => {
      const submenuTitleLink = e.target.closest(".apk-submenu-title-link");
      if (submenuTitleLink && submenuTitleLink.dataset.menuItemId) {
        // Track the access
        this.trackMenuAccess(submenuTitleLink);

        // Close menu after a short delay to allow for tracking
        setTimeout(() => {
          this.closeMenu();
        }, 100);
      }
    });
  }

  handleMenuItemClick(e, item) {
    if (item.dataset.submenu) {
      this.handleSubmenuItemClick(e, item);
    } else {
      this.handleRegularItemClick(item);
    }
  }

  handleSubmenuItemClick(e, item) {
    // Check if item is active on desktop (submenu visible)
    if (!this._isMobile && item.classList.contains("active")) {
      if (this.tryNavigateToActiveItem(item)) {
        return;
      }
    }

    // Prevent navigation and show submenu
    e.preventDefault();
    this.handleItemClick(e.currentTarget);
  }

  tryNavigateToActiveItem(item) {
    const link = item.querySelector(".apk-menu-link");
    if (!link || !link.href || link.href === "#") {
      return false;
    }

    // Track the access before navigation
    this.trackMenuAccess(item);
    this.navigateToLink(link);
    this.closeMenu();
    return true;
  }

  handleRegularItemClick(item) {
    const link = item.querySelector(".apk-menu-link");
    if (link && link.href && link.href !== "#") {
      // Track the access before navigation
      this.trackMenuAccess(item);
      this.navigateToLink(link);
    }
    this.closeMenu();
  }

  navigateToLink(link) {
    if (link.target === "_blank") {
      window.open(link.href, "_blank");
    } else {
      window.location.href = link.href;
    }
  }

  setupInitialState() {
    // Esconder todas as colunas exceto a primeira
    this.menuColumns.forEach((column, index) => {
      if (index > 0) {
        column.classList.remove("active");
      }
    });

    // Esconder todos os conteúdos de submenu
    this.submenuContents.forEach((content) => {
      content.classList.remove("active");
    });
  }

  toggleMenu() {
    if (this.isOpen) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  openMenu() {
    this.isOpen = true;
    this.megaMenu.classList.add("active");
    this.menuToggle.classList.add("active");
    this.menuToggle.setAttribute("aria-expanded", "true");

    // Reset para o estado inicial
    this.resetToLevel(1);

    // Focus no primeiro item do menu
    setTimeout(() => {
      const firstMenuItem = this.megaMenu.querySelector(".apk-menu-link");
      if (firstMenuItem) {
        firstMenuItem.focus();
      }
    }, 100);
  }

  closeMenu() {
    this.isOpen = false;
    this.megaMenu.classList.remove("active");
    this.menuToggle.classList.remove("active");
    this.menuToggle.setAttribute("aria-expanded", "false");

    document.body.style.overflow = "";
    document.body.classList.remove("menu-level-3-open");

    // Remover classe level-2-open do level-1
    const level1Column = document.querySelector(".apk-level-1");
    if (level1Column) {
      level1Column.classList.remove("level-2-open");
    }

    // Reset do estado do menu
    this.resetToLevel(1);
    this.clearActiveItems();
  }

  handleItemHover(item) {
    // Apenas funciona no desktop
    if (!this.isOpen || this._isMobile) return;

    const submenuKey = item.dataset.submenu;
    const currentLevel = this.getCurrentLevel(item);

    // Limpar seleções do mesmo nível e níveis superiores
    this.clearActiveItemsFromLevel(currentLevel);

    // Marcar item atual como ativo
    item.classList.add("active");
    this.activeItems.set(currentLevel, item);

    // Adicionar classe has-active-item ao nível 1 quando há item ativo
    this.updateLevel1ActiveState();

    // Sempre esconder níveis superiores ao atual, independentemente de ter submenu
    this.hideColumnsAfterLevel(currentLevel);

    // Mostrar submenu apenas se existir
    if (submenuKey) {
      this.showSubmenu(submenuKey, currentLevel);
    }
  }

  handleItemClick(item) {
    // Verifica se o item tem submenu
    if (!item.dataset.submenu) {
      // Item sem submenu - permitir navegação
      const link = item.querySelector(".apk-menu-link");
      if (link && link.href && link.href !== "#") {
        // Verificar se deve abrir em nova aba
        if (link.target === "_blank") {
          window.open(link.href, "_blank");
        } else {
          window.location.href = link.href;
        }
        return;
      }
      this.closeMenu();
      return;
    }

    if (this._isMobile) {
      const submenuId = item.dataset.submenu;
      const currentLevel = this.getCurrentLevel(item);

      if (currentLevel === 1) {
        this.showSubmenuMobile(submenuId, currentLevel);
      } else if (currentLevel === 2) {
        this.showLevel3Overlay(submenuId);
      }
    } else {
      // Desktop: usar hover
      this.handleItemHover(item);
    }
  }

  showSubmenuMobile(submenuKey, currentLevel) {
    const targetLevel = currentLevel + 1;

    if (targetLevel === 2) {
      // Para o nível 2, inserir abaixo do item clicado
      this.showLevel2BelowItem(submenuKey, currentLevel);
    } else if (targetLevel === 3) {
      // Para o nível 3, mostrar overlay completo
      this.showLevel3Overlay(submenuKey);
    }
  }

  showLevel2BelowItem(submenuKey, currentLevel) {
    // Encontrar o item ativo
    const activeItem = document.querySelector(
      `.apk-menu-item[data-submenu="${submenuKey}"]`
    );
    if (!activeItem) return;

    // Prevenir execução simultânea
    if (this.isToggling) return;
    this.isToggling = true;

    // Verificar se o item já está expandido (toggle)
    const isAlreadyExpanded = activeItem.classList.contains("mobile-expanded");
    const level1Column = document.querySelector(".apk-level-1");

    if (isAlreadyExpanded) {
      // Fechar: remover nível 2 existente e classe do item
      const existingLevel2 = document.querySelector(".mobile-level-2");
      if (existingLevel2) {
        activeItem.classList.remove("mobile-expanded");
        // Remover classe do level-1
        if (level1Column) {
          level1Column.classList.remove("level-2-open");
        }
        existingLevel2.style.maxHeight = "0";
        existingLevel2.style.opacity = "0";
        existingLevel2.style.transform = "translateY(-10px)";
        setTimeout(() => {
          existingLevel2.remove();
          this.isToggling = false;
        }, 300);
      } else {
        this.isToggling = false;
      }
      this.activeLevel = 1;
      return;
    }

    // Remover qualquer nível 2 existente com animação
    const previousLevel2 = document.querySelector(".mobile-level-2");
    if (previousLevel2) {
      // Remover classe ativa do item anterior
      const previousActiveItem = document.querySelector(
        ".apk-menu-item.mobile-expanded"
      );
      if (previousActiveItem) {
        previousActiveItem.classList.remove("mobile-expanded");
      }

      // Remover classe do level-1 temporariamente
      if (level1Column) {
        level1Column.classList.remove("level-2-open");
      }

      previousLevel2.style.maxHeight = "0";
      previousLevel2.style.opacity = "0";
      previousLevel2.style.transform = "translateY(-10px)";
      setTimeout(() => {
        previousLevel2.remove();
      }, 300);
    }

    // Delay para garantir que a animação anterior termine
    setTimeout(
      () => {
        // Remove brutalmente qualquer nível 2 duplicado criado por dupla-execução
        document.querySelectorAll('.mobile-level-2').forEach(dup => dup.remove());

        // Adicionar classe para marcar o item como expandido no mobile
        activeItem.classList.add("mobile-expanded");

        // Adicionar classe no level-1 para indicar que nivel 2 está aberto
        if (level1Column) {
          level1Column.classList.add("level-2-open");
        }

        // Buscar conteúdo do submenu
        const submenuContent = document.querySelector(
          `.apk-submenu-content[data-parent="${submenuKey}"]`
        );
        if (!submenuContent) {
          this.isToggling = false;
          return;
        }

        // Criar elemento do nível 2 mobile
        const mobileLevel2 = document.createElement("div");
        mobileLevel2.className = "mobile-level-2";
        mobileLevel2.innerHTML = submenuContent.innerHTML;

        // Inserir logo após o item ativo
        activeItem.insertAdjacentElement("afterend", mobileLevel2);

        // Animar entrada com delay para permitir inserção no DOM
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            mobileLevel2.classList.add("active");
            this.isToggling = false;
          });
        });

        this.activeLevel = 2;
      },
      previousLevel2 ? 320 : 0
    );
  }

  showLevel3Overlay(submenuKey) {
    // ── Batch all DOM reads first ──────────────────────────────────────────
    const targetColumn = document.querySelector(
      '.apk-menu-column[data-level="3"]'
    );
    if (!targetColumn) return;

    const activeContents = Array.from(
      targetColumn.querySelectorAll(".apk-submenu-content.active")
    );
    const targetContent = targetColumn.querySelector(
      `.apk-submenu-content[data-parent="${submenuKey}"]`
    );
    if (!targetContent) return;

    const level2Item = document.querySelector(
      `.apk-menu-item[data-submenu="${submenuKey}"]`
    );

    // Derive level1Name entirely from reads before any write
    let level1Name = "Voltar";
    if (level2Item) {
      const level2Container =
        level2Item.closest(".apk-submenu-content") ||
        document
          .querySelector(
            `.apk-submenu-content .apk-menu-item[data-submenu="${submenuKey}"]`
          )
          ?.closest(".apk-submenu-content");

      if (level2Container) {
        const parentKey = level2Container.getAttribute("data-parent");
        if (parentKey) {
          const level1Span = document.querySelector(
            `.apk-menu-item[data-submenu="${parentKey}"] .apk-menu-link span`
          );
          if (level1Span) {
            level1Name = level1Span.textContent.trim();
          }
        }
      }
    }

    // ── Batch all DOM writes ───────────────────────────────────────────────
    activeContents.forEach((content) => content.classList.remove("active"));
    targetContent.classList.add("active");
    targetColumn.classList.add("entering", "active");

    setTimeout(() => {
      targetColumn.classList.remove("entering");
    }, 500);

    this.backButton.innerHTML = `
              <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
<path d='M12.5979 3.40132C11.6886 2.49291 10.5304 1.87448 9.26966 1.62419C8.00896 1.3739 6.70235 1.50299 5.515 1.99515C4.32765 2.48731 3.31286 3.32043 2.59891 4.38921C1.88496 5.45799 1.50391 6.71445 1.50391 7.99976C1.50391 9.28507 1.88496 10.5415 2.59891 11.6103C3.31286 12.6791 4.32765 13.5122 5.515 14.0044C6.70235 14.4965 8.00896 14.6256 9.26966 14.3753C10.5304 14.125 11.6886 13.5066 12.5979 12.5982C13.8156 11.3776 14.4995 9.7239 14.4995 7.99976C14.4995 6.27561 13.8156 4.62187 12.5979 3.40132ZM7.35286 9.64695C7.39931 9.6934 7.43616 9.74855 7.4613 9.80925C7.48644 9.86994 7.49938 9.935 7.49938 10.0007C7.49938 10.0664 7.48644 10.1314 7.4613 10.1921C7.43616 10.2528 7.39931 10.308 7.35286 10.3544C7.3064 10.4009 7.25125 10.4378 7.19055 10.4629C7.12986 10.488 7.0648 10.501 6.9991 10.501C6.93341 10.501 6.86835 10.488 6.80766 10.4629C6.74696 10.4378 6.69181 10.4009 6.64536 10.3544L4.64536 8.35445C4.59887 8.30801 4.56199 8.25286 4.53683 8.19217C4.51166 8.13147 4.49871 8.0664 4.49871 8.0007C4.49871 7.93499 4.51166 7.86993 4.53683 7.80923C4.56199 7.74853 4.59887 7.69338 4.64536 7.64695L6.64536 5.64695C6.69181 5.60049 6.74696 5.56364 6.80766 5.5385C6.86835 5.51336 6.93341 5.50042 6.9991 5.50042C7.0648 5.50042 7.12986 5.51336 7.19055 5.5385C7.25125 5.56364 7.3064 5.60049 7.35286 5.64695C7.39931 5.6934 7.43616 5.74855 7.4613 5.80925C7.48644 5.86994 7.49938 5.935 7.49938 6.0007C7.49938 6.06639 7.48644 6.13145 7.4613 6.19214C7.43616 6.25284 7.39931 6.30799 7.35286 6.35445L5.70536 8.00007L7.35286 9.64695ZM10.8529 9.64695C10.8993 9.6934 10.9362 9.74855 10.9613 9.80925C10.9864 9.86994 10.9994 9.935 10.9994 10.0007C10.9994 10.0664 10.9864 10.1314 10.9613 10.1921C10.9362 10.2528 10.8993 10.308 10.8529 10.3544C10.8064 10.4009 10.7513 10.4378 10.6906 10.4629C10.6299 10.488 10.5648 10.501 10.4991 10.501C10.4334 10.501 10.3684 10.488 10.3077 10.4629C10.247 10.4378 10.1918 10.4009 10.1454 10.3544L8.14536 8.35445C8.09887 8.30801 8.06199 8.25286 8.03683 8.19217C8.01166 8.13147 7.99871 8.0664 7.99871 8.0007C7.99871 7.93499 8.01166 7.86993 8.03683 7.80923C8.06199 7.74853 8.09887 7.69338 8.14536 7.64695L10.1454 5.64695C10.1918 5.60049 10.247 5.56364 10.3077 5.5385C10.3684 5.51336 10.4334 5.50042 10.4991 5.50042C10.5648 5.50042 10.6299 5.51336 10.6906 5.5385C10.7513 5.56364 10.8064 5.60049 10.8529 5.64695C10.8993 5.6934 10.9362 5.74855 10.9613 5.80925C10.9864 5.86994 10.9994 5.935 10.9994 6.0007C10.9994 6.06639 10.9864 6.13145 10.9613 6.19214C10.9362 6.25284 10.8993 6.30799 10.8529 6.35445L9.20723 8.00007L10.8529 9.64695Z' fill='#ABABAB'/>
</svg>
                <span>${level1Name}</span>
            `;

    this.activeLevel = 3;

    // Prevenir scroll no body e adicionar classe
    document.body.style.overflow = "hidden";
    document.body.classList.add("menu-level-3-open");

    // Defer animation to next frame so writes above are committed first
    requestAnimationFrame(() => this.animateLevel3Items(targetContent));
  }

  animateLevel3Items(container) {
    const menuItems = Array.from(container.querySelectorAll(".apk-menu-item"));
    menuItems.forEach((item, index) => {
      // Batch both style properties in one cssText write (single layout invalidation per item)
      item.style.cssText = "opacity:0;transform:translateY(20px)";
      setTimeout(() => {
        item.style.cssText =
          "transition:all 0.3s cubic-bezier(0.4,0,0.2,1);opacity:1;transform:translateY(0)";
      }, 100 + index * 50);
    });
  }

  goBackFromLevel3() {
    const level3Column = document.querySelector(".apk-menu-column.apk-level-3");
    if (level3Column) {
      // Adicionar classe de saída
      level3Column.classList.add("leaving");

      // Após animação, remover classes e resetar
      setTimeout(() => {
        level3Column.classList.remove("active", "leaving");
        this.activeLevel = 2;

        // Restaurar scroll no body e remover classe
        document.body.style.overflow = "";
        document.body.classList.remove("menu-level-3-open");

        // Limpar itens ativos do nível 3
        this.clearActiveItemsFromLevel(3);
      }, 400);
    }
  }

  resetToDesktop() {
    // Restaurar scroll no body e remover classe
    document.body.style.overflow = "";
    document.body.classList.remove("menu-level-3-open");

    // Reset para comportamento desktop
    this.resetToLevel(this.activeLevel);
  }

  showSubmenu(submenuKey, currentLevel) {
    // No mobile, usar lógica específica
    if (this._isMobile) {
      this.showSubmenuMobile(submenuKey, currentLevel);
      return;
    }

    const targetLevel = currentLevel + 1;
    const targetColumn = document.querySelector(
      `.apk-menu-column[data-level="${targetLevel}"]`
    );
    if (!targetColumn) return;

    // Batch reads
    const activeContents = Array.from(
      targetColumn.querySelectorAll(".apk-submenu-content.active")
    );
    const targetContent = targetColumn.querySelector(
      `.apk-submenu-content[data-parent="${submenuKey}"]`
    );
    if (!targetContent) return;

    // Batch writes
    activeContents.forEach((content) => content.classList.remove("active"));
    targetContent.classList.add("active");
    targetColumn.classList.add("active");
    this.activeLevel = Math.max(this.activeLevel, targetLevel);
    this.hideColumnsAfterLevel(targetLevel);
  }

  getCurrentLevel(item) {
    const column = item.closest(".apk-menu-column");
    return parseInt(column.dataset.level);
  }

  resetToLevel(level) {
    this.activeLevel = level;

    // classList.toggle reads dataset once and writes once per column — no interleaved reflow
    this.menuColumns.forEach((column) => {
      column.classList.toggle(
        "active",
        parseInt(column.dataset.level) <= level
      );
    });

    // Limpar itens ativos de níveis superiores
    this.clearActiveItemsFromLevel(level + 1);
  }

  hideColumnsAfterLevel(level) {
    // Batch all reads first
    const columnsToHide = Array.from(this.menuColumns).filter(
      (column) => parseInt(column.dataset.level) > level
    );
    const contentsToDeactivate = columnsToHide.flatMap((column) =>
      Array.from(column.querySelectorAll(".apk-submenu-content.active"))
    );

    // Batch all writes
    columnsToHide.forEach((column) => column.classList.remove("active"));
    contentsToDeactivate.forEach((content) =>
      content.classList.remove("active")
    );
  }

  clearActiveItems() {
    this.menuItems.forEach((item) => {
      item.classList.remove("active");
      item.classList.remove("mobile-expanded");
    });
    this.activeItems.clear();

    // Atualizar estado do nível 1
    this.updateLevel1ActiveState();

    // Remover níveis 2 mobile
    const mobileLevel2Items = document.querySelectorAll(".mobile-level-2");
    mobileLevel2Items.forEach((item) => item.remove());
  }

  clearActiveItemsFromLevel(level) {
    // Batch reads: collect items and their levels before any write
    const toDeactivate = Array.from(this.menuItems)
      .map((item) => ({
        item,
        itemLevel: this.getCurrentLevel(item),
      }))
      .filter(({ itemLevel }) => itemLevel >= level);

    // Batch writes
    toDeactivate.forEach(({ item, itemLevel }) => {
      item.classList.remove("active");
      this.activeItems.delete(itemLevel);
    });

    // Atualizar estado do nível 1
    this.updateLevel1ActiveState();

    // Se limpando nível 2 ou superior, remover níveis 2 mobile
    if (level <= 2) {
      const mobileLevel2Items = document.querySelectorAll(".mobile-level-2");
      mobileLevel2Items.forEach((item) => item.remove());
    }
  }

  handleArrowDown(allItemsInColumn, currentIndex) {
    const nextIndex = (currentIndex + 1) % allItemsInColumn.length;
    allItemsInColumn[nextIndex].focus();
  }

  handleArrowUp(allItemsInColumn, currentIndex) {
    const prevIndex =
      currentIndex === 0 ? allItemsInColumn.length - 1 : currentIndex - 1;
    allItemsInColumn[prevIndex].focus();
  }

  handleArrowRight(currentItem, currentLevel) {
    // Expandir submenu se existir
    const parentItem = currentItem.closest(".apk-menu-item");
    if (!parentItem.dataset.submenu) {
      return;
    }

    this.handleItemHover(parentItem);
    // Focus no primeiro item do próximo nível
    setTimeout(() => {
      const nextColumn = document.querySelector(
        `.apk-menu-column[data-level="${currentLevel + 1}"].active`
      );
      if (nextColumn) {
        const firstLink = nextColumn.querySelector(".apk-menu-link");
        if (firstLink) firstLink.focus();
      }
    }, 100);
  }

  handleArrowLeft(currentLevel) {
    // Voltar para o nível anterior
    if (currentLevel <= 1) {
      return;
    }

    const prevColumn = document.querySelector(
      `.apk-menu-column[data-level="${currentLevel - 1}"]`
    );
    if (!prevColumn) {
      return;
    }

    const activeItem = this.activeItems.get(currentLevel - 1);
    if (!activeItem) {
      return;
    }

    const activeLink = activeItem.querySelector(".apk-menu-link");
    if (activeLink) activeLink.focus();
  }

  handleEnterOrSpace(currentItem) {
    // Se tem submenu, expandir; senão, seguir o link
    const menuItem = currentItem.closest(".apk-menu-item");
    if (menuItem.dataset.submenu) {
      this.handleItemHover(menuItem);
      return;
    }

    // Navegar para o link real
    const link = menuItem.querySelector(".apk-menu-link");
    if (link && link.href && link.href !== "#") {
      // Verificar target antes de navegar
      if (link.target === "_blank") {
        window.open(link.href, "_blank");
      } else {
        window.location.href = link.href;
      }
    }
    this.closeMenu();
  }

  handleKeyNavigation(e, currentItem) {
    const currentLevel = this.getCurrentLevel(currentItem);
    const currentColumn = currentItem.closest(".apk-menu-column");
    const allItemsInColumn = Array.from(
      currentColumn.querySelectorAll(".apk-menu-item .apk-menu-link")
    );
    const currentIndex = allItemsInColumn.indexOf(e.target);

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        this.handleArrowDown(allItemsInColumn, currentIndex);
        break;

      case "ArrowUp":
        e.preventDefault();
        this.handleArrowUp(allItemsInColumn, currentIndex);
        break;

      case "ArrowRight":
        e.preventDefault();
        this.handleArrowRight(currentItem, currentLevel);
        break;

      case "ArrowLeft":
        e.preventDefault();
        this.handleArrowLeft(currentLevel);
        break;

      case "Enter":
      case " ":
        e.preventDefault();
        this.handleEnterOrSpace(currentItem);
        break;
      default:
        break;
    }
  }

  // Método para gerenciar estado ativo dos níveis
  updateLevelsActiveState() {
    // Derive active state from in-memory map — no DOM reads, no forced reflow
    const hasLevel1Active = this.activeItems.has(1);
    const hasLevel2Active = this.activeItems.has(2);

    // Batch writes
    if (this._level1Column)
      this._level1Column.classList.toggle("has-active-item", hasLevel1Active);
    if (this._level2Column)
      this._level2Column.classList.toggle("has-active-item", hasLevel2Active);
  }

  // Método para compatibilidade (manter referência antiga)
  updateLevel1ActiveState() {
    this.updateLevelsActiveState();
  }

  // Método para adicionar transições suaves (opcional)
  addTransitionEffects() {
    this.menuColumns.forEach((column) => {
      column.addEventListener("transitionend", (e) => {
        if (
          e.propertyName === "transform" &&
          !column.classList.contains("active")
        ) {
          // Limpar conteúdos quando a coluna sai completamente
          const activeContents = column.querySelectorAll(
            ".apk-submenu-content.active"
          );
          activeContents.forEach((content) =>
            content.classList.remove("active")
          );
        }
      });
    });
  }
}

// Inicializar quando o DOM estiver carregado
document.addEventListener("DOMContentLoaded", () => {
  // Trava para garantir que o menu só seja instanciado UMA única vez, mesmo se o script for carregado duas vezes por plugins de cache
  if (window.apkMegaMenuInitialized) return; 
  window.apkMegaMenuInitialized = true;
  
  new ApkMegaMenu();
});
